import { render, staticRenderFns } from "./CommunityCalendar.vue?vue&type=template&id=46ffda1b&scoped=true&"
import script from "./CommunityCalendar.ts?vue&type=script&lang=ts&"
export * from "./CommunityCalendar.ts?vue&type=script&lang=ts&"
import style0 from "./CommunityCalendar.vue?vue&type=style&index=0&id=46ffda1b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ffda1b",
  null
  
)

export default component.exports